module.exports = {
  "country": "DE",
  "artist": "Lena",
  "song": "Satellite",
  "year": "2010",
  "place": "1",
  "spotify": "2UjNsh4ipNrmog6wdS2JVv"
};